import { ReactNode } from "react";
import { Button } from "primereact/button";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";

export const CATALOG_CONTENT_STYLE = {
  padding: "var(--space-32) var(--space-40) var(--space-40)",
};

export const CatalogCard = ({ heading, actions, children }: {
  heading: string;
  actions?: ReactNode;
  children: ReactNode;
}) => (
  <div
    className="surface-card border-1 surface-border overflow-hidden"
    style={{ borderRadius: "var(--radius-md)" }}
  >
    <div
      className="surface-50 border-bottom-1 surface-border flex flex-wrap align-items-center justify-content-center gap-3"
      style={{ padding: "var(--space-16) var(--space-40)" }}
    >
      <h2 className="m-0 text-xl font-semibold text-900">{heading}</h2>
      {actions}
    </div>
    <div style={CATALOG_CONTENT_STYLE}>{children}</div>
  </div>
);

export const CatalogSearchField = ({
  inputId,
  value,
  onChange,
  placeholder = "Buscar por nombre",
  label = "Buscar",
}: {
  inputId: string;
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
  /** Solo hace falta cuando hay más de un buscador en la misma fila de filtros. */
  label?: string;
}) => (
  <div className="flex flex-column" style={{ gap: "var(--space-6)" }}>
    <label htmlFor={inputId} className="text-600 text-sm">{label}</label>
    <div className="relative">
      <IconField iconPosition="left" className="w-full">
        <InputIcon className="pi pi-search" />
        <InputText
          id={inputId}
          value={value}
          onChange={(event) => onChange(event.target.value)}
          placeholder={placeholder}
          className="w-full pr-5"
          style={{ minWidth: "14rem" }}
        />
      </IconField>
      {value && (
        <Button
          type="button"
          icon="pi pi-times"
          text
          rounded
          severity="secondary"
          aria-label="Limpiar búsqueda"
          className="absolute right-0 top-0 h-full"
          onClick={() => onChange("")}
        />
      )}
    </div>
  </div>
);
